import React from 'react'
import CourseList from '../../modules/Course'

const CoursePage = () => {
  return <CourseList />
}

export default CoursePage
